import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { message } from 'antd';
import {
  changeLanguage,
  setNotificationExpanded,
  setShowNav,
  setShowSearchNav,
  setChatbotModalOpen,
} from '../../app/base/commonSlice';
import { setMode } from '../../app/theme/themeSlice';
import { setFeedbackDrawerOpen } from '../../components/ui/Feedback/store/stateSlice';

const showMessage = (key: string) => {
  message.info({
    content: `${key}`,
    className: 'shortcut-message',
  });
};

const useShortcut = () => {
  const dispatch = useDispatch();
  const [searchType, setSearchType] = useState('my-brac');

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const tag = document.activeElement?.tagName;
      const classes = document.activeElement?.className;
      // ignore keypress if the eletent is textarea, input, and quill editor
      if (
        tag === 'TEXTAREA' ||
        tag === 'INPUT' ||
        classes?.includes('ql-editor')
      ) {
        return false;
      }

      // ignore inner condition if ctrl key press
      if (!event.ctrlKey) {
        if (
          event.key === 's' ||
          event.key === 'S' ||
          (event.shiftKey && event.key === 's')
        ) {
          event.preventDefault();
          setSearchType('my-brac');
          showMessage('S');
          dispatch(setShowSearchNav(true));
          dispatch(setShowNav(false));
        }

        if (
          event.key === 'c' ||
          event.key === 'C' ||
          (event.shiftKey && event.key === 'c')
        ) {
          event.preventDefault();
          showMessage('C');
          setSearchType('user_profiles');
          dispatch(setShowSearchNav(true));
          dispatch(setShowNav(false));
        }

        if (
          event.key === 'e' ||
          event.key === 'E' ||
          (event.shiftKey && event.key === 'e')
        ) {
          event.preventDefault();
          showMessage('E');
          dispatch(changeLanguage('en'));
        }
        if (
          event.key === 'b' ||
          event.key === 'B' ||
          (event.shiftKey && event.key === 'b')
        ) {
          event.preventDefault();
          showMessage('B');
          dispatch(changeLanguage('bn'));
        }
        if (
          event.key === 'd' ||
          event.key === 'D' ||
          (event.shiftKey && event.key === 'd')
        ) {
          event.preventDefault();
          showMessage('D');
          dispatch(setMode('dark'));
        }
        if (
          event.key === 'l' ||
          event.key === 'L' ||
          (event.shiftKey && event.key === 'l')
        ) {
          event.preventDefault();
          showMessage('L');
          dispatch(setMode('light'));
        }

        if (
          event.key === 'f' ||
          event.key === 'F' ||
          (event.shiftKey && event.key === 'f')
        ) {
          event.preventDefault();
          showMessage('F');
          dispatch(setFeedbackDrawerOpen(true));
        }

        if (
          event.key === 'n' ||
          event.key === 'N' ||
          (event.shiftKey && event.key === 'n')
        ) {
          event.preventDefault();
          showMessage('N');
          dispatch(setNotificationExpanded(true));
        }
        if (
          event.key === 'h' ||
          event.key === 'H' ||
          (event.shiftKey && event.key === 'h')
        ) {
          showMessage('H');
          event.preventDefault();
          dispatch(setChatbotModalOpen(true));
        }
      }
    };

    // Add event listener when component mounts
    document.addEventListener('keydown', handleKeyDown);

    // Remove event listener when component unmounts
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [dispatch]); // Empty dependency array ensures the effect runs only once when the component mounts

  return {
    profileSearch: searchType,
    setSearchType,
  };
};

export default useShortcut;
